import type { FilePart } from "@opencode-ai/sdk/v2"

// MultiTool: a share-scrubbed attachment — the payload never left the user's
// machine; only this marker (plus mime/filename) was published. Rendered as an
// inert "attachment not published" chip on the share viewer.
export function stripped(part: FilePart) {
  return part.url.startsWith("stripped:")
}

export function attached(part: FilePart) {
  if (part.url.startsWith("data:")) return true
  // Path-referenced attachment (e.g. a .pptx attached by file:// and materialized
  // server-side for tool access) — show it as a chip too, like a base64 one.
  // @-file mentions also use file:// URLs but carry a source text range; those
  // stay `inline` (handled below), so exclude them here.
  if (part.url.startsWith("file:") && part.source?.text?.start === undefined) return true
  if (stripped(part) && part.source?.text?.start === undefined) return true
  return false
}

export function inline(part: FilePart) {
  if (attached(part)) return false
  return part.source?.text?.start !== undefined && part.source?.text?.end !== undefined
}

export function kind(part: FilePart) {
  // A stripped image has no bytes to preview — render the generic file chip.
  if (stripped(part)) return "file"
  return part.mime.startsWith("image/") ? "image" : "file"
}
